import {getSelectedPaymentOptionIndex} from '../../../selectors/PaymentOptionSelectors/getSelectedPaymentOptionIndex';
import {getSettings} from '../../../selectors/selectors';
import store from '../../../store/store';
import DomUtils from '../../../utils/DomUtils';
import Track from '../../../utils/tracking';
import {stopOrderProcessing} from '../../site-actions';
import {setPaymentOptionErrorMessage} from '../payment-actions';
import sendRazorpayResponse from './sendRazorpayResponse';
import doMetric from '../../../tracking/bigQueryMetricRecorder';

export default (razorpayData) => {
  const state = store.getState();
  const settings = getSettings(state);
  const razorpayModalSettings = settings?.razorpay_modal_settings;
  const razorpayModalConfig = settings?.razorpay_modal_config;
  const RAZORPAY_SCRIPT_URL = settings?.razorpay_script_url || 'https://checkout-static-next.razorpay.com/build/7845eba182531cb24939ef72593cf58bd7209e5e/checkout.js';
  const RAZORPAY_SCRIPT_INTEGRITY = settings?.razorpay_script_integrity || 'sha384-h1+n7mc1lDxMPDSNvP7y/KDJ3nhkLp8W91bN0tnhiA7QnVyFJUMPkC3ZLk3D8dR3';
  let rzp1;
  
  const onDismiss = () => {
    rzp1.close();
    store.dispatch(stopOrderProcessing(false));
  
    doMetric(
      'razorpay',
      [
        {name: 'Dismissed Razorpay modal', value: true},
      ],
    );
  };
  
  let options = {
    key: razorpayData?.keyId,
    amount: razorpayData?.amount,
    currency: razorpayData?.currency,
    name: razorpayData?.name,
    order_id: razorpayData?.orderId,
    handler(response) {
      sendRazorpayResponse(response)(store.dispatch);
      
      doMetric(
        'razorpay',
        [
          {name: 'Razorpay response sent', value: true},
        ],
      );
    },
  };
  
  if (razorpayModalSettings) {
    options = {
      ...options,
      modal: {
        ondismiss: onDismiss,
        ...razorpayModalSettings,
      },
    };
  } else {
    options = {
      ...options,
      modal: {
        ondismiss: onDismiss,
      },
    };
  }
  
  if (razorpayModalConfig) {
    options = {
      ...options,
      config: {
        ...razorpayModalConfig,
      },
    };
  }
  
  const stopOrderAndThrowError = () => {
    store.dispatch(stopOrderProcessing(false));
    const selectedOptionIndex = getSelectedPaymentOptionIndex(store.getState());
    store.dispatch(setPaymentOptionErrorMessage(selectedOptionIndex, 'razorpay.checkout.error'));
  };
  
  if (settings.enable_razorpay_script_load) {
    DomUtils.addScript(RAZORPAY_SCRIPT_URL, true, RAZORPAY_SCRIPT_INTEGRITY)
      .then(() => {
        rzp1 = new Razorpay(options);
        rzp1.open();
      
        doMetric(
          'razorpay',
          [
            {name: 'Razorpay script loaded', value: true},
          ],
        );
      })
      .catch((err) => {
        Track.track(`Error loading Razorpay script ${err}`);
        
        stopOrderAndThrowError();
      });
  } else {
    Track.track('Razorpay script not loaded, enable_razorpay_script_load not set');
  
    stopOrderAndThrowError();
  }
};
